const ignoreDomains = [
  'gmail',
  'yahoo',
  'outlook',
  'hotmail',
  'aol',
  'msn',
  'live',
];

/**
 * Gets the URL from the Email address
 * NOTE: Mirrors the current mobile behavior (detecting specific ignored domains)
 * @param email string
 * @return string
 */
export function getCompanyUrlFromEmail(email: string) {
  const companyUrl = email.split('@')[1];
  const companyDomain = companyUrl.split('.')[0];

  if (ignoreDomains.includes(companyDomain)) {
    return null;
  }

  return `https://${companyUrl}`;
}
